type IconProps = React.SVGProps<SVGSVGElement>;

const MapPinFilled: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 1.875C11.6576 1.875 13.2468 2.53395 14.4189 3.70605C15.591 4.87816 16.25 6.4674 16.25 8.125C16.25 13.75 10 18.125 10 18.125C10 18.125 3.75 13.75 3.75 8.125C3.75 6.4674 4.40895 4.87816 5.58105 3.70605C6.75316 2.53395 8.3424 1.875 10 1.875ZM10 5.625C8.61929 5.625 7.5 6.74429 7.5 8.125C7.5 9.50571 8.61929 10.625 10 10.625C11.3807 10.625 12.5 9.50571 12.5 8.125C12.5 6.74429 11.3807 5.625 10 5.625Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MapPinFilled;
